import { PostMessageData } from './post-message';

export function addMessageListener(callback: (data: PostMessageData) => void) {
  const listener = (event: MessageEvent<PostMessageData>) => {
    // skips messages that were not posted by the widget or has no data
    if (!event.data?.isUserWay) {
      return;
    }

    callback(event.data);
  };

  window.addEventListener('message', listener);

  return {
    removeMessageListener: () =>
      window.removeEventListener('message', listener),
  };
}
